module.exports = __webpack_public_path__ + "static/undraw_JavaScript_frameworks-3a649c6bbc95bbba9c28ee893c54e258.svg";